import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Prices from '../views/Prices.vue'
import Schedules from '../views/Schedules.vue'
import Settings from '../views/Settings.vue'
import Admins from '../views/Admins.vue'
import AuthLayout from '../views/auth/Layout.vue'
import Login from '../views/auth/Login.vue'
import ForgotPassword from '../views/auth/ForgotPassword.vue'
import ChargeStations from '../views/ChargeStations.vue'
import DodoDealers from '../views/DodoDealers.vue'
import ChatbotKnowledge from '../views/ChatbotKnowledge.vue'
import Bunce from '../views/Bunce.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/auth',
    name: 'auth',
    component: AuthLayout,
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'login',
        name: 'login',
        component: Login,
        meta: {
          requireAuth: false
        },
      },
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: ForgotPassword,
        meta: {
          requireAuth: false
        },
      }
    ]
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/prices',
    name: 'prices',
    component: Prices,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/schedules',
    name: 'schedules',
    component: Schedules,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/admins',
    name: 'admins',
    component: Admins,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/stations',
    name: 'stations',
    component: ChargeStations,
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/dodo-dealers',
    name: 'dodo-dealers',
    component: DodoDealers,
    meta: { requireAuth: true }
  },
  {
    path: '/chatbot-knowledge',
    name: 'chatbot-knowledge',
    component: ChatbotKnowledge,
    meta: { requireAuth: true }
  },
  {
    path: '/bunce',
    name: 'bunce',
    component: Bunce,
    meta: { requireAuth: true }
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((a, b, next) => {
  const isLoggedIn = !!sessionStorage.getItem('token')
  if (!isLoggedIn && a.meta.requireAuth) {
    router.push({ name: 'login' });
  } else if (a.name === 'login' && isLoggedIn) {
    router.push({ name: 'home' });
  }
  next()
})

export default router
